import React, { useEffect, useContext } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { TableRow } from '@material-ui/core'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../context/DailyMonitoringDetailsFiltersContext'
import EmptyCells from '../../../../../components/EmptyCellSmall'
import DefaultTableCellSmallSpace from '../../../../../components/DefaultTableCellSmallSpace'
import { GET_PHARMACIES_QUANTITY_HISTORY } from '../../../../../queries/dailyMonitoring'
import ColoredTableCell, { Colors } from '../../../../../components/ColoredTableCell'
import { getDaysInMonth, DaysInMonth } from '../../../../../utils/Helpers'
import { defaultFormatMonthTimeZone } from '../../../../../utils/consts'

const title = 'QTD. Lojas c/ venda'
export default function DailyPharmaciesQuantity (): JSX.Element {
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_PHARMACIES_QUANTITY_HISTORY, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    const createdAt: any = {
      initialDate: `${filters.date.year}-${filters.date.month}||/M`,
      finalDate: `${filters.date.year}-${filters.date.month}||/M`,
      ...defaultFormatMonthTimeZone
    }

    getData({
      variables: { filters: { states: filters.states, cities: filters.cities, createdAt } }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <EmptyCells title={title} />
  if (loading || !data) return <EmptyCells title={title} />
  if (error) return <EmptyCells title={title} />
  if (!data.ordersAggs?.aggregations?.salesOverTime) return <EmptyCells title={title} />

  const { buckets } = data.ordersAggs?.aggregations?.salesOverTime
  const total = buckets.reduce((acumulador: number, valorAtual: any) => {
    return acumulador + valorAtual.delivered.quantity.value
  }, 0)

  const avg = total / buckets.length
  const averages = {
    low: avg - avg * 0.5,
    average: avg,
    high: avg + avg * 0.5
  }

  const newBuckets = JSON.parse(JSON.stringify(buckets))
  newBuckets.map((bucket: any) => {
    bucket.value = bucket.delivered.quantity.value
    if (bucket.value < averages.low) {
      bucket.color = Colors.red
    } else if (bucket.value >= averages.low && bucket.value <= averages.average) {
      bucket.color = Colors.orange
    } else if (bucket.value > averages.average && bucket.value <= averages.high) {
      bucket.color = Colors.green
    } else if (bucket.value > averages.high) {
      bucket.color = Colors.blue
    }
  })

  return (
    <TableRow>
      <DefaultTableCellSmallSpace style={{ fontSize: 12 }}>{title}</DefaultTableCellSmallSpace>
      {getDaysInMonth(filters.date.year, filters.date.month).map((day: DaysInMonth) => {
        const bucket = newBuckets.filter((b: any) => moment.parseZone(String(b.key_as_string)).isSame(moment(day.date, 'DD/MMM/YYYY'), 'day'))[0]
        return !isEmpty(bucket) ? <ColoredTableCell style={{ fontSize: 12 }} key={`${bucket.key_as_string}-${bucket.color}=${bucket.value}`} className={bucket.color}>{bucket.value}</ColoredTableCell> : <DefaultTableCellSmallSpace>-</DefaultTableCellSmallSpace>
      })}
    </TableRow>
  )
}
